/**
 * VWO FME (Feature Management Engine) integration for layout-level flags
 *
 * This module provides utilities to resolve VWO feature flags server-side
 * for layout-level concerns like the HeaderClearChoice2 swap.
 */

export { LAYOUT_FEATURE_FLAGS, getDefaultLayoutFlags } from './layout-feature-flags';
export type { LayoutFeatureFlagKey, LayoutFeatureFlags } from './layout-feature-flags';
export { resolveFeatureFlags } from './resolve-feature-flags';
export type { ResolvedFeatureFlag, VWOFlagDecision, ResolveFeatureFlagsResult } from './resolve-feature-flags';
export { getVwoFmeSdkKey, getVwoFmeAccountId } from './get-vwo-fme-config';
export { resolveVariationId } from './resolve-variation-id';
export { isPhoneSwapTreatment } from './is-phone-swap-treatment';
export { isGhostScheduleTreatment } from './is-ghost-schedule-treatment';
export { getOrCreateVisitorId } from './visitor-id';
